import ManageEventDetails from "./ManageEventDetails";
export default ManageEventDetails;
